import { Step } from '../../components/global/StepsFlow';
import CustomDomainNudge from '../../components/marketing/CustomDomainNudge';
import { PocketflowsEmailAddress } from '../../types/marketing';
import { LoadedUser } from '../../interfaces';
import {
  getAccessLevel,
  hasValidatedCustomDomain,
  isEmailSenderDisabledInUi,
} from '.';
import { trimString } from '../global';

interface Args<TValues> {
  emailAddresses: PocketflowsEmailAddress<true>[] | null | undefined;
  user: LoadedUser | null | undefined;
  selectedEmailAddressId: string | null | undefined;
  isDefaultVisited: boolean;
  required?: boolean;
  onSetUpCustomDomain: () => void;
  values: TValues;
}

/// Shared by the campaign and automation steppers so senders behave the same in both
export function buildSendFromStep<
  TValues extends { emailAddressId?: string | null },
>({
  emailAddresses,
  user,
  selectedEmailAddressId,
  isDefaultVisited,
  required,
  onSetUpCustomDomain,
}: Args<TValues>): Step<TValues> | false {
  if (!emailAddresses?.length) return false;

  return {
    title: 'Send from',
    description: selectedEmailAddressId
      ? emailAddresses.find(email => email.id === selectedEmailAddressId)
          ?.email_address
      : 'Choose the sending email',
    selectButtonText: 'Update Email',
    buttonText: 'Continue',
    isDefaultVisited,
    banner:
      user &&
      getAccessLevel(user) === 'full' &&
      !hasValidatedCustomDomain(emailAddresses) ? (
        <CustomDomainNudge onSetUp={onSetUpCustomDomain} />
      ) : undefined,
    inputs: [
      {
        contentType: 'select',
        name: 'emailAddressId',
        label: 'From Email Address',
        placeholder: 'Choose the sending email',
        required,
        options: emailAddresses.map(email => ({
          value: email.id,
          label: `${trimString(email.display_name, 20)} (${
            email.email_address
          })`,
          disabled: isEmailSenderDisabledInUi(email),
        })),
      },
    ],
  } as Step<TValues>;
}
